var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92232 17.8398V10.098H8.53412L8.92234 7.06676H5.92232V5.13601C5.92232 4.26132 6.16602 3.66245 7.42139 3.66245H9.01208V0.959967C8.23812 0.877023 7.46016 0.836974 6.68177 0.840004C4.37318 0.840004 2.78816 2.24934 2.78816 4.83658V7.06109H0.193359V10.0923H2.79382V17.8398H5.92232Z",
    fill: "#2F4DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f0cd38f59089c762d6a5ae452a8e15e7.svg";
export { ForwardRef as ReactComponent };